import { cn } from "@heroui/react";
import type { ReactNode } from "react";

type InertIconProps = {
  children: ReactNode;
  className?: string;
  label?: string;
};

export default function InertIcon({ children, className, label }: InertIconProps) {
  return (
    <span
      aria-hidden={label ? undefined : true}
      aria-label={label}
      className={cn(
        "inline-flex items-center justify-center text-default-500",
        className,
      )}
      role={label ? "img" : undefined}
    >
      {children}
    </span>
  );
}
